import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSlideYTransition,[(_vm.onboardingData
			&& _vm.onboardingData.id
			&& (!_vm.isDismissed || _vm.persistent))?_c('div',{staticStyle:{"position":"relative","max-width":"1000px"}},[_c('div',{staticClass:"onboarding-card",class:{
				'onboarding-card--drawer-open': _vm.drawerOpen && _vm.$vuetify.breakpoint.mdOnly,
				'onboarding-card--small': _vm.$vuetify.breakpoint.smAndDown
			},style:({
				...(_vm.isDialog && {
					margin: '0',
				}),
			})},[(!_vm.persistent)?_c(VBtn,{staticClass:"close-button",attrs:{"icon":""},on:{"click":function($event){return _vm.toggleOnboardingDismissed(_vm.onboardingData.id)}}},[_c(VIcon,[_vm._v("mdi-close")])],1):_vm._e(),_c('div',{staticClass:"onboarding-card-text-container"},[_c('div',{staticClass:"onboarding-card-title",style:({
						...(_vm.$vuetify.breakpoint.xsOnly && {
							fontSize: '25px',
							margin: _vm.onboardingData.articleUrl ? '0 0 10px 0' : '30px 0 5px 0',
							lineHeight: '1.2',
						}),
						...(_vm.$vuetify.breakpoint.smOnly && {
							fontSize: '25px',
							margin: '-10px 0 10px 0',
						}),
						...(_vm.$vuetify.breakpoint.mdOnly && {
							fontSize: '28px',
							margin: '0 0 10px 0',
						}),
						...(_vm.$vuetify.breakpoint.lgAndUp && {
							fontSize: '32px',
							margin: '0 0 10px 0',
						}),
					})},[_vm._v(" "+_vm._s(_vm.onboardingData.title)+" ")]),(_vm.onboardingData.descriptionHtml)?_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.onboardingData.descriptionHtml),expression:"onboardingData.descriptionHtml"}]}):_c('div',{staticClass:"onboarding-card-subtitle",style:({
						...(_vm.$vuetify.breakpoint.xsOnly && {
							fontSize: '12px',
							margin: '0 0 12px 0',
							padding: '0 0 0 0',
						}),
						...(_vm.$vuetify.breakpoint.smOnly && {
							fontSize: '15px',
							margin: '0 0 12px 0',
						}),
						...(_vm.$vuetify.breakpoint.mdOnly && {
							fontSize: '16px',
							margin: '0 0 12px 0',
							maxWidth: '400px',
						}),
						...(_vm.$vuetify.breakpoint.lgAndUp && {
							fontSize: '18px',
							margin: '0 0 12px 0',
						}),
					})},[_vm._v(" "+_vm._s(_vm.onboardingData.description)+" ")])]),_c('div',{staticClass:"onboarding-card-media-wrapper"},[_c('div',{staticClass:"onboarding-card-media-container"},[(_vm.onboardingData.videoUrl)?_c('training-video-player',{staticClass:"training-video",attrs:{"video-url":_vm.onboardingData.videoUrl}}):_c('div',{staticClass:"placeholder-image"},[(_vm.onboardingData.avatar)?[_c('div',{staticClass:"onboarding-image-container"},[(typeof _vm.onboardingData.avatar !== 'string')?_c('runnit-image',{attrs:{"avatar":_vm.onboardingData.avatar,"is-avatar":"","no-click":""}}):_c('div',{staticStyle:{"width":"200px","height":"200px","display":"flex","justify-content":"center","align-items":"center","background-color":"var(--grey-950)"}},[_c(VIcon,{staticStyle:{"font-size":"64px"}},[_vm._v("mdi-image-outline")])],1)],1)]:_c('div',{staticClass:"onboarding-image-container"},[_c('img',{staticStyle:{"width":"200px","height":"200px","object-fit":"cover"},attrs:{"src":_vm.onboardingData.imageUrl,"alt":"Node Definition Image"}})])],2)],1),(_vm.onboardingData.articleUrl)?_c('base-button',{staticClass:"onboarding-card-button mt-4",staticStyle:{"padding":"7px 25px","font-size":"16px","width":"100%"},attrs:{"secondary":""},on:{"click":_vm.goToArticle}},[_c(VIcon,{staticStyle:{"margin-right":"8px","font-size":"18px"}},[_vm._v("mdi-book-open-page-variant")]),_vm._v(" Read Tutorial ")],1):_vm._e()],1)],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }